import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import Select from "react-select";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_EMPLOYEES_LIST,
} from "../RollCallConfig/RollCallConfig";
import { Collapse, Spin } from "antd";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  flexRender,
  getSortedRowModel,
} from "@tanstack/react-table";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
const { Panel } = Collapse;
const GROUPING_CONFIG = {
  111: ["Bio Id", "Employee Name", "EmpId", "Employee", "groupcolumn"],
  105: [
    "EmplId",
    "Employee",
    "Date",
    "Status",
    "Breaks",
    "Break Duration",
    "Work Duration",
  ],
};
const EXPORT_GROUPING_CONFIG = {
  111: ["Bio Id", "Employee Name", "EmpId", "Employee", "groupcolumn"],
  105: [
    "EmplId",
    "Employee",
    "Date",
    "Status",
    "Breaks",
    "Break Duration",
    "Work Duration",
  ],
};

const GROUPING_COLUMNS = {
  111: ["Bio Id", "Employee Name", "EmpId", "Employee", "groupcolumn"],
  105: [
    "EmplId",
    "Employee",
    "Date",
    "Status",
    "Breaks",
    "Break Duration",
    "Work Duration",
  ],
};

const getCleanKey = (header) => {
  return header.replace(/\s+/g, "_").toLowerCase();
};

// Reusable Grouping Function - Main Logic
const applyGroupingToData = (data, groupKeys) => {
  if (!groupKeys?.length || !data?.length) return data;

  const groups = [];
  let currentGroup = [];
  let lastKey = null;

  data.forEach((row) => {
    const currentGroupKey = groupKeys
      .map((k) => String(row[k] ?? ""))
      .join("||");

    if (currentGroupKey !== lastKey) {
      if (currentGroup.length) groups.push(currentGroup);
      currentGroup = [row];
      lastKey = currentGroupKey;
    } else {
      currentGroup.push(row);
    }
  });

  if (currentGroup.length) groups.push(currentGroup);

  const result = [];
  groups.forEach((group) => {
    group.forEach((row, index) => {
      const newRow = { ...row };
      if (index > 0) {
        groupKeys.forEach((key) => {
          newRow[key] = "";
        });
      }
      result.push(newRow);
    });
  });

  return result;
};

const groupByAdjacentKeys = (data, groupKeys) => {
  if (!data?.length || !groupKeys?.length) return [];

  const groups = [];
  let currentGroup = [];
  let lastKey = null;

  data.forEach((row) => {
    const currentKey = groupKeys.map((k) => String(row[k] ?? "")).join("||");

    if (currentKey !== lastKey) {
      if (currentGroup.length) {
        groups.push(currentGroup);
      }
      currentGroup = [row];
      lastKey = currentKey;
    } else {
      currentGroup.push(row);
    }
  });

  if (currentGroup.length) {
    groups.push(currentGroup);
  }

  return groups;
};

const buildColumns = (headers, pageIndex, pageSize, id) => [
  {
    header: "S.No",
    cell: ({ row }) => pageIndex * pageSize + row.index + 1,
  },
  ...headers.map((h) => ({
    header: h,
    accessorKey: h,
    cell: (info) => {
      const value = info.getValue();

      if (id === "107" && h === "Map" && typeof value === "string") {
        return <span dangerouslySetInnerHTML={{ __html: value }} />;
      }

      return value ?? "-";
    },
  })),
];

const RollcallGroupReports = () => {
  const { id } = useParams();
  const groupColumns = GROUPING_CONFIG[id] || [];
  const isGroupedReport = !!GROUPING_CONFIG[id];
  const [Loading, setLoading] = useState();
  const [headerLoading, setHeaderLoading] = useState();
  const [headerData, setHeaderData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [deptData, setDeptData] = useState([]);
  const [branchdata, setbranchdata] = useState([]);
  const [shiftdata, setshiftdata] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedDep, setSelectedDep] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const [selectedStartDt, setSelectedStartDt] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [selectedEndDt, setSelectedEndDt] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [selectedmonth, setSelectedmonth] = useState("");
  const [selectedYear, Setselectedyear] = useState("");
  const [reportData, setReportData] = useState([]);
  // const [colData, SetColdata] = useState([]);

  const [selectedFormattedStDt, setSelectedFormatedStDt] = useState("");
  const [selectedFormattedEndDt, setSelectedFormatedEndDt] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [sorting, setSorting] = useState(() =>
    groupColumns.length ? [{ id: groupColumns[0], desc: false }] : [],
  );
  const [searchText, setSearchText] = useState("");
  const handleSearch = (e) => {
    setSearchText(e.target.value);
    setPageIndex(0); // reset pagination on search
  };

  const navigate = useNavigate();
  const location = useLocation();

  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  // const pageSize = 10;
  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [
    { value: 10, label: "10" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [activeKey, setActiveKey] = useState(1);
  const togglePanel = () => {
    setActiveKey(activeKey ? null : "1");
  };
  const filteredData = useMemo(() => {
    if (!searchText) return data;

    const lower = searchText.toLowerCase();

    return data.filter((row) =>
      headers.some((h) => {
        const cleanKey = getCleanKey(h);
        return String(row[cleanKey] ?? "")
          .toLowerCase()
          .includes(lower);
      }),
    );
  }, [data, searchText, headers]);

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (!id) return;
    if (tokenData && superIdData) {
      const fetchHeaderData = async () => {
        setHeaderLoading(true);
        try {
          const res = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/reports/getreporthead?reportiid=${id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          const data = await res.json();

          if (data?.status) {
            setHeaderData(data.ResultData || []);
          } else {
            console.error("Failed to load report header:", data?.Message);
          }
        } catch (err) {
          console.error("Fetch error:", err);
        } finally {
          setHeaderLoading(false);
        }
      };

      fetchHeaderData();
    }
  }, [id, superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMPLOYEES_LIST}?superid=${superIdData}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setEmployees(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setEmployees([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [superIdData, tokenData]);

  const empOptions = [
    { value: "", label: "All" },
    ...employees.map((emp) => ({
      value: emp.RegId,
      label: `${emp.UserName} (${emp.Badge})`,
    })),
  ];

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDepartments = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }
          const data = await response.json();
          if (data.status) {
            const activeRecords = data.ResultData?.filter(
              (item) => item.IsActive,
            );
            setDeptData(activeRecords);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };
      fetchDepartments();
    }
  }, [tokenData, superIdData]);

  const departmentOptions = [
    { value: "", label: "All" },
    ...(deptData?.map((item) => ({
      value: item.DepartmentId,
      label: item.Name,
    })) ?? []),
  ];

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchbranches = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,

            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }

          const data = await response.json();

          if (data.status) {
            setbranchdata(data.ResultData);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };
      fetchbranches();
    }
  }, [superIdData, tokenData]);

  const branchOptions = [
    { value: "", label: "All" },
    ...(branchdata?.map((item) => ({
      value: item.BranchId,
      label: item.Name,
    })) ?? []),
  ];

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchShifts = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/shifts/getShiftsTypes?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const data = await response.json();

          setshiftdata(data.ResultData);
        } catch (err) {
          console.log(err.message);
        }
      };

      fetchShifts();
    }
  }, [superIdData, tokenData]);

  const shiftOptions = [
    { value: "", label: "All" },
    ...(shiftdata?.map((item) => ({
      value: item.shiftid,
      label: item.Name,
    })) ?? []),
  ];

  const handleStartDtChange = (e) => {
    setSelectedStartDt(e.target.value);
  };
  const handleEndDtChange = (e) => {
    setSelectedEndDt(e.target.value);
  };

  const reportName = headerData[0]?.name;
  const reportFilters = headerData[0]?.Filter;
  const reportTitle = headerData[0]?.Description;
  useEffect(() => {
    if (id) {
      const now = new Date();

      const currentMonthName = now.toLocaleString("default", { month: "long" });
      const currentMonthOption = monthOptions.find(
        (m) => m.value === currentMonthName,
      );

      const currentYear = String(now.getFullYear());
      const currentYearOption = yearOptions.find(
        (y) => y.value === currentYear,
      );
      setSelectedFormatedStDt("");
      setSelectedFormatedEndDt("");
      setSelectedStartDt(new Date().toISOString().split("T")[0]);
      setSelectedEndDt(new Date().toISOString().split("T")[0]);

      setSelectedmonth(
        reportFilters?.includes("Month") ? currentMonthOption || null : null,
      );

      Setselectedyear(
        reportFilters?.includes("Year") ? currentYearOption || null : null,
      );
      setData([]);
    }
  }, [id, reportFilters]);

  const sortedFilteredData = useMemo(() => {
    if (!sorting.length) return filteredData;

    const [{ id, desc }] = sorting;

    return [...filteredData].sort((a, b) => {
      const valA = a[id];
      const valB = b[id];

      // Date sort
      const isDateA =
        typeof valA === "string" && /^\d{4}-\d{2}-\d{2}T/.test(valA);
      const isDateB =
        typeof valB === "string" && /^\d{4}-\d{2}-\d{2}T/.test(valB);

      if (isDateA && isDateB) {
        return desc
          ? new Date(valB) - new Date(valA)
          : new Date(valA) - new Date(valB);
      }

      // Number sort
      if (!isNaN(valA) && !isNaN(valB)) {
        return desc ? valB - valA : valA - valB;
      }

      // String sort
      return desc
        ? String(valB).localeCompare(String(valA))
        : String(valA).localeCompare(String(valB));
    });
  }, [filteredData, sorting]);

  const groupedData = useMemo(() => {
    const groupKeysRaw = GROUPING_CONFIG[id] || [];
    if (!groupKeysRaw.length) return [];

    // Convert to clean keys for grouping
    const cleanGroupKeys = groupKeysRaw.map(getCleanKey);

    return groupByAdjacentKeys(sortedFilteredData, cleanGroupKeys);
  }, [sortedFilteredData, id]);

  const paginatedGroups = useMemo(() => {
    const start = pageIndex * pageSize;
    const end = start + pageSize;
    return groupedData.slice(start, end);
  }, [groupedData, pageIndex, pageSize]);

  const columnsTanStack = useMemo(() => {
    return headers?.length
      ? buildColumns(headers, pageIndex, pageSize, id)
      : [];
  }, [headers, pageIndex, pageSize, id]);

  const table = useReactTable({
    data: filteredData,
    columns: columnsTanStack,

    state: {
      pagination: { pageIndex, pageSize },
      sorting,
    },

    onSortingChange: setSorting,

    onPaginationChange: (updater) => {
      const next =
        typeof updater === "function"
          ? updater({ pageIndex, pageSize })
          : updater;

      setPageIndex(next.pageIndex);
    },

    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
  const fetchReportData = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPageIndex(0);

    if (!tokenData || !superIdData) return;

    try {
      const queryParams = new URLSearchParams({
        reportiid: id,
        superid: superIdData,
      });

      if (selectedFormattedStDt) {
        queryParams.append("StartDate", selectedFormattedStDt);
      } else {
        queryParams.append("StartDate", selectedStartDt);
      }
      if (selectedFormattedEndDt) {
        queryParams.append("EndDate", selectedFormattedEndDt);
      } else {
        queryParams.append("EndDate", selectedEndDt);
      }

      if (selectedEmp?.value) queryParams.append("RegId", selectedEmp.value);
      if (selectedDep?.value) queryParams.append("DeptId", selectedDep.value);
      if (selectedShift?.value)
        queryParams.append("ShiftId", selectedShift.value);
      if (selectedBranch?.value)
        queryParams.append("BranchId", selectedBranch.value);

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/reports/getReports?${queryParams.toString()}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      );

      const result = await response.json();

      if (result?.status) {
        const originalHeaders = result.header || [];

        setHeaders(originalHeaders);

        const processedData = result.ResultData.map((row) => {
          const newRow = {};
          originalHeaders.forEach((header) => {
            const cleanKey = getCleanKey(header);
            newRow[cleanKey] = row[header];
          });
          return newRow;
        });

        setData(processedData);
        setReportData(processedData);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const monthOptions = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];

  const currentYear = new Date().getFullYear();

  const yearOptions = Array.from({ length: 2 }, (_, i) => {
    const year = currentYear - i;
    return { value: String(year), label: String(year) };
  }).reverse();

  useEffect(() => {
    if (selectedmonth?.value && selectedYear?.value) {
      const monthMap = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
      };

      const selectedMonthNum = monthMap[selectedmonth.value];
      const selectedYearNum = parseInt(selectedYear.value);

      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;

      const isCurrentYear = selectedYearNum === currentYear;
      const isCurrentMonth = isCurrentYear && selectedMonthNum === currentMonth;

      const isFuture =
        selectedYearNum > currentYear ||
        (selectedYearNum === currentYear && selectedMonthNum > currentMonth);

      const startDay = isCurrentMonth || isFuture ? today.getDate() : 1;

      console.log(startDay);

      const startDate = new Date(
        selectedYearNum,
        selectedMonthNum - 1,

        1,
      );

      const endDate = new Date(selectedYearNum, selectedMonthNum, 0);

      const format = (d) => {
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      const formattedStartDate = format(startDate);
      const formattedEndDate = format(endDate);

      setSelectedFormatedStDt(formattedStartDate);
      setSelectedFormatedEndDt(formattedEndDate);
    }
  }, [selectedmonth, selectedYear]);

  useEffect(() => {
    setSelectedEmp(null);
    setSelectedDep(null);
    setSelectedShift(null);
    setSelectedBranch(null);
    setSelectedStartDt(new Date().toISOString().split("T")[0]);
    setSelectedEndDt(new Date().toISOString().split("T")[0]);
    setReportData(null);

    setHeaderData([]);
  }, [id]);

  const exportToExcel = () => {
    if (!reportData || reportData.length === 0) {
      alert("No data to export!");
      return;
    }

    setExcelLoading(true);

    setTimeout(() => {
      const originalHeaders = headers || [];
      const groupKeysRaw =
        GROUPING_COLUMNS[id] || EXPORT_GROUPING_CONFIG[id] || [];
      const groupKeys = groupKeysRaw.map(getCleanKey);

      const grouped = groupByAdjacentKeys(reportData, groupKeys);

      const finalData = [];
      grouped.forEach((group) => {
        group.forEach((row, index) => {
          const newRow = { ...row };
          if (index > 0) {
            groupKeys.forEach((key) => (newRow[key] = ""));
          }
          finalData.push(newRow);
        });
      });

      const formattedData = finalData.map((row) => {
        const excelRow = {};
        originalHeaders.forEach((header) => {
          const cleanKey = getCleanKey(header);
          excelRow[header] = row[cleanKey] ?? "";
        });
        return excelRow;
      });

      const excelHeaders = [...originalHeaders];
      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        header: excelHeaders,
      });

      // Merging Logic
      const merges = [];
      let rowIndex = 0;
      grouped.forEach((group) => {
        const groupSize = group.length;
        if (groupSize > 1) {
          groupKeysRaw.forEach((header) => {
            const colIndex = excelHeaders.indexOf(header);
            if (colIndex !== -1) {
              merges.push({
                s: { r: rowIndex + 1, c: colIndex },
                e: { r: rowIndex + groupSize, c: colIndex },
              });
            }
          });
        }
        rowIndex += groupSize;
      });

      if (merges.length > 0) worksheet["!merges"] = merges;

      const colWidths = [];
      for (let C = 0; C < excelHeaders.length; C++) {
        let maxWidth = excelHeaders[C].length + 1;

        for (let R = 0; R < formattedData.length; R++) {
          const cellValue = formattedData[R][excelHeaders[C]] || "";
          maxWidth = Math.max(maxWidth, String(cellValue).length);
        }

        const headerLower = excelHeaders[C].toLowerCase();

        if (
          headerLower.includes("employee") ||
          headerLower.includes("name") ||
          headerLower.includes("bio")
        ) {
          maxWidth = Math.max(maxWidth, 16);
        } else if (
          headerLower.includes("duration") ||
          headerLower.includes("time") ||
          headerLower.includes("date")
        ) {
          maxWidth = Math.max(maxWidth, 7);
        } else {
          maxWidth = Math.max(maxWidth, 6);
        }

        colWidths.push({ wch: Math.min(maxWidth + 1, 35) });
      }
      worksheet["!cols"] = colWidths;
      // Styles
      const headerStyle = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "2E8B57" } },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };
      const dataStyle = {
        alignment: { vertical: "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };

      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const addr = XLSX.utils.encode_cell({ r: R, c: C });
          if (worksheet[addr]) {
            worksheet[addr].s = R === 0 ? headerStyle : dataStyle;
          }
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      const fileName = reportName
        ? `${reportName.replace(/[^a-zA-Z0-9\s-]/g, "_")}.xlsx`
        : `Report_${id}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      setExcelLoading(false);
    }, 300);
  };

  const exportToPDF = () => {
    if (!reportData || reportData?.length === 0) return;

    setPdfLoading(true);

    setTimeout(() => {
      exportPDF();
      setPdfLoading(false);
    }, 100);
  };

  const openReportInNewTab = () => {
    if (!reportData || reportData.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Data",
        text: "Please generate the report first.",
      });
      return;
    }

    const groupKeys = EXPORT_GROUPING_CONFIG[id] || [];
    const cleanGroupKeys = groupKeys.map(getCleanKey); // ← Important

    const finalData = applyGroupingToData(reportData, cleanGroupKeys);

    const tableRows = finalData.map((row) =>
      headers.map((header) => {
        const key = getCleanKey(header);
        let value = row[key];

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
          value = value.split("T")[0];
        }
        return value ?? "";
      }),
    );

    const isWideReport = headers.length > 12;

    const htmlContent = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${reportName || "Report"}</title>
  <style>
    body { font-family: Arial, sans-serif; padding: 20px; background: #f8f9fa; }
    .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
    table { border-collapse: collapse; width: 100%; min-width: ${isWideReport ? "2800px" : "1400px"}; }
    th, td { border: 1px solid #ccc; padding: 6px 8px; font-size: 12px; }
    th { background: #007bff; color: white; }
    tr:nth-child(even) { background-color: #f8f9fa; }
  </style>
</head>
<body>
  <div class="header">
    <h2>${reportName || "Report"}</h2>
   
  </div>
  <table id="reportTable">
    <thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>
    <tbody>
      ${tableRows.map((row) => `<tr>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`).join("")}
    </tbody>
  </table>
  <script>
    function downloadPDF() {
      alert("Use main PDF button for better export");
    }
  </script>
</body>
</html>`;

    const newWindow = window.open(
      "",
      "_blank",
      "width=1600,height=900,scrollbars=yes,resizable=yes",
    );
    if (newWindow) {
      newWindow.document.write(htmlContent);
      newWindow.document.close();
    }
  };
  const handleReload = () => {
    window.location.reload();
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const exportPDF = () => {
    if (!reportData || reportData.length === 0) return;

    const groupKeysRaw = EXPORT_GROUPING_CONFIG[id] || [];
    const groupKeys = groupKeysRaw.map(getCleanKey);

    // Use same grouping logic as Excel
    const grouped = groupByAdjacentKeys(reportData, groupKeys);

    const finalData = [];
    grouped.forEach((group) => {
      group.forEach((row, index) => {
        const newRow = { ...row };
        if (index > 0) {
          groupKeys.forEach((key) => {
            newRow[key] = "";
          });
        }
        finalData.push(newRow);
      });
    });

    const is105 = id === "105";
    const doc = new jsPDF(is105 ? "p" : "l", "mm", "a4");

    const tableBody = finalData.map((row) =>
      headers.map((h) => {
        const cleanKey = getCleanKey(h);
        let value = row[cleanKey] ?? "-";
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
          value = value.split("T")[0];
        }
        return value;
      }),
    );

    const reportTitle = id === "105" ? "Break Details" : reportName || "Report";

    doc.text(reportTitle, 5, 10);

    autoTable(doc, {
      head: [headers],
      body: tableBody,
      startY: 15,
      tableWidth: "auto",
      margin: is105
        ? { top: 15, left: 8, right: 8, bottom: 10 }
        : { top: 15, left: 5, right: 5, bottom: 10 },

      styles: {
        fontSize: is105 ? 8 : 7,
        cellPadding: 2,
        lineHeight: 1.3,
      },

      headStyles: {
        fillColor: [41, 128, 185],
        fontSize: is105 ? 9 : 8,
        fontStyle: "bold",
      },

      didDrawPage: () => {
        const pageHeight = doc.internal.pageSize.getHeight();
        const pageWidth = doc.internal.pageSize.getWidth();

        doc.setFontSize(7);
        doc.setTextColor(100);
        doc.text(
          "RollCall Attendance System. Powered by Perennial Code IT Consultants",
          5,
          pageHeight - 5,
        );
        doc.text(new Date().toLocaleString(), pageWidth - 5, pageHeight - 5, {
          align: "right",
        });
      },
    });

    doc.save(`${reportTitle}.pdf`);
  };

  const renderFilters = () => {
    return (
      <div className="row align-items-end">
        <div className="col-lg-12">
          <div className="row">
            {reportFilters?.includes("Month") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Month :</label>
                  <Select
                    classNamePrefix="react-select"
                    options={monthOptions}
                    placeholder="Choose month"
                    allowClear
                    value={selectedmonth}
                    onChange={setSelectedmonth}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("Year") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Year</label>
                  <Select
                    classNamePrefix="react-select"
                    options={yearOptions}
                    placeholder="Choose year"
                    allowClear
                    value={selectedYear}
                    onChange={Setselectedyear}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("StartDate") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedStartDt}
                    onChange={handleStartDtChange}
                  ></input>
                </div>
              </div>
            )}
            {reportFilters?.includes("EndDate") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedEndDt}
                    onChange={handleEndDtChange}
                  ></input>
                </div>
              </div>
            )}
            {reportFilters?.includes("payperiod") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Pay Period</label>
                  <Select
                    classNamePrefix="react-select"
                    allowClear
                    options={[
                      { value: "Mar-2025", label: "Mar-2025" },
                      { value: "Feb-2025", label: "Feb-2025" },
                      { value: "Jan-2025", label: "Jan-2025" },
                      { value: "Dec-2024", label: "Dec-2024" },
                      { value: "Nov-2024", label: "Nov-2024" },
                      { value: "Oct-2024", label: "Oct-2024" },
                      { value: "Sep-2024", label: "Sep-2024" },
                      { value: "Aug-2024", label: "Aug-2024" },
                      { value: "Jul-2024", label: "Jul-2024" },
                      { value: "Jun-2024", label: "Jun-2024" },
                      { value: "May-2024", label: "May-2024" },
                      { value: "Apr-2024", label: "Apr-2024" },
                    ]}
                    placeholder="Choose Pay Period"
                    // onChange={(e) => handleFilterChange("payperiod", e.value)}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("Branch") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Branch</label>
                  <Select
                    placeholder="Branch"
                    value={selectedBranch}
                    onChange={setSelectedBranch}
                    allowClear
                    options={branchOptions}
                    style={{ width: 170 }}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("Dept") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Department</label>
                  <Select
                    placeholder="Department"
                    value={selectedDep}
                    onChange={setSelectedDep}
                    allowClear
                    options={departmentOptions}
                    style={{ width: 170 }}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("Employee") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Employee</label>
                  <Select
                    placeholder="Employee"
                    value={selectedEmp}
                    onChange={setSelectedEmp}
                    allowClear
                    options={empOptions}
                    style={{ width: 200 }}
                  />
                </div>
              </div>
            )}
            {reportFilters?.includes("shift") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="mb-3">
                  <label className="form-label">Shift</label>
                  <Select
                    placeholder="Shifts"
                    value={selectedShift}
                    onChange={setSelectedShift}
                    allowClear
                    options={shiftOptions}
                    style={{ width: 170 }}
                  />
                </div>
              </div>
            )}
            <div className="col-md-1 mt-4">
              <button
                className="btn btn-primary mt-1"
                type="submit"
                onClick={fetchReportData}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
            <div className="col-md-1 mt-4">
              <button
                className={`btn btn-${activeKey ? `secondary` : `primary`} mt-1`}
                onClick={togglePanel}
              >
                <i className={`fa ${activeKey ? "fa-x" : "fa-filter"}`}></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-2"></div>
      </div>
    );
  };

  useEffect(() => {
    setPageIndex(0);
    setHeaders([]);
    setSearchText("");
  }, [id]);

  return (
    <>
      {(pdfLoading || excelLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      {headerLoading ? (
        <div className="page-wrapper">
          <div className="content d-flex justify-content-center align-items-center">
            <Spin size="large" />
          </div>
        </div>
      ) : (
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/rollcall/dashboard">
                          <i className="fas fa-home fa-lg" />
                        </Link>
                      </li>
                      <h4 className="breadcrumb-item " aria-current="page">
                        {reportName}
                      </h4>
                    </ol>
                  </nav>
                  <h6>Manage {reportTitle}</h6>
                </div>
              </div>
              {perm.Export && (
                <ul className="table-top-head">
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={exportToPDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={exportToExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>

                  <li onClick={handleReload}>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderRefreshTooltip}
                    >
                      <Link data-bs-toggle="tooltip" data-bs-placement="top">
                        <RotateCcw />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <button
                    className="btn btn-primary"
                    onClick={openReportInNewTab}
                    style={{ marginLeft: "10px" }}
                    title="View in New Tab"
                  >
                    <i className="feather-eye"></i>
                  </button>
                </ul>
              )}
            </div>
            {perm.Read ? (
              <>
                <style>
                  {`
                    .ant-collapse .ant-collapse-content .ant-collapse-content-box {
                      padding: 0px;
                    }

                    .ant-collapse .ant-collapse-item .ant-collapse-header {
                      padding: 0px;
                    }
                  `}
                </style>
                <Collapse activeKey={activeKey} ghost expandIcon={() => null}>
                  <Panel key="1">
                    <div className="card border-0">
                      <div className="card-body">{renderFilters()}</div>
                    </div>
                  </Panel>
                </Collapse>

                <div className="card  ">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Search..."
                      value={searchText}
                      onChange={handleSearch}
                      style={{ width: "250px" }}
                    />
                    {activeKey === null && (
                      <button
                        className={`btn btn-${activeKey ? `secondary` : `primary`} mt-1`}
                        onClick={togglePanel}
                      >
                        <i
                          className={`fa ${activeKey ? "fa-x" : "fa-filter"}`}
                        ></i>
                      </button>
                    )}
                  </div>

                  <div className="card-body">
                    <div className="">
                      {Loading ? (
                        <div className="text-center my-4">
                          <Spin size="large" />
                          <p>Loading data...</p>
                        </div>
                      ) : (
                        <>
                          {!Loading && !isGroupedReport && (
                            <>
                              <div className="table-responsive brand-table">
                                <div className="dataTables_wrapper dt-bootstrap5 no-footer table-responsive">
                                  <table className="table datatable dataTable no-footer">
                                    <thead className="">
                                      {table?.getHeaderGroups()?.map((hg) => (
                                        <tr key={hg.id}>
                                          {hg.headers.map((h) => (
                                            <th
                                              key={h.id}
                                              onClick={h.column.getToggleSortingHandler()}
                                              style={{ cursor: "pointer" }}
                                            >
                                              {flexRender(
                                                h.column.columnDef.header,
                                                h.getContext(),
                                              )}
                                              {{
                                                asc: (
                                                  <i className="fa-solid fa-caret-up"></i>
                                                ),
                                                desc: (
                                                  <i className="fa-solid fa-caret-down"></i>
                                                ),
                                              }[h.column.getIsSorted()] ?? null}
                                            </th>
                                          ))}
                                        </tr>
                                      ))}
                                    </thead>
                                    <tbody>
                                      {table
                                        ?.getRowModel()
                                        ?.rows?.map((row) => (
                                          <tr
                                            className="border border-start-0 border-end-0"
                                            key={row.id}
                                          >
                                            {row
                                              .getVisibleCells()
                                              .map((cell) => (
                                                <td key={cell.id}>
                                                  {flexRender(
                                                    cell.column.columnDef.cell,
                                                    cell.getContext(),
                                                  )}
                                                </td>
                                              ))}
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    Page size
                                    <Select
                                      value={pageSizeOptions.find(
                                        (opt) => opt.value === pageSize,
                                      )}
                                      onChange={(option) =>
                                        setPageSize(option.value)
                                      }
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      options={pageSizeOptions}
                                      styles={{
                                        container: (base) => ({
                                          ...base,
                                          width: 120,
                                        }),
                                      }}
                                    />
                                  </div>
                                  <PaginationControls
                                    pageIndex={pageIndex}
                                    totalPages={table.getPageCount()}
                                    setPageIndex={setPageIndex}
                                  />
                                </div>
                              </div>
                            </>
                          )}

                          {!Loading && isGroupedReport && (
                            <>
                              <div className="table-responsive brand-table">
                                <div className="dataTables_wrapper dt-bootstrap5 no-footer table-responsive">
                                  <table className="table datatable dataTable no-footer">
                                    <thead className="">
                                      <tr>
                                        <th>S.No</th>
                                        {headers.map((h) => {
                                          const isGroupColumn =
                                            groupColumns.includes(h);
                                          return (
                                            <th
                                              key={h}
                                              onClick={() => {
                                                if (!isGroupColumn) return;
                                                setSorting((prev) => {
                                                  if (prev[0]?.id === h) {
                                                    return [
                                                      {
                                                        id: h,
                                                        desc: !prev[0].desc,
                                                      },
                                                    ];
                                                  }
                                                  return [
                                                    { id: h, desc: false },
                                                  ];
                                                });
                                              }}
                                              style={{
                                                cursor: isGroupColumn
                                                  ? "pointer"
                                                  : "default",
                                                userSelect: "none",
                                              }}
                                            >
                                              {h}
                                              {isGroupColumn &&
                                                sorting[0]?.id === h &&
                                                (sorting[0].desc ? (
                                                  <i className="fa-solid fa-caret-down"></i>
                                                ) : (
                                                  <i className="fa-solid fa-caret-up"></i>
                                                ))}
                                            </th>
                                          );
                                        })}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {paginatedGroups.map((group, gIdx) =>
                                        group.map((row, rIdx) => (
                                          <tr
                                            className="border border-start-0 border-end-0"
                                            key={`${gIdx}-${rIdx}`}
                                          >
                                            {rIdx === 0 && (
                                              <td rowSpan={group.length}>
                                                {pageIndex * pageSize +
                                                  gIdx +
                                                  1}
                                              </td>
                                            )}

                                            {headers.map((h) => {
                                              const isGroupColumn =
                                                groupColumns.includes(h);
                                              const cleanKey = getCleanKey(h);

                                              if (isGroupColumn && rIdx !== 0)
                                                return null;

                                              if (isGroupColumn) {
                                                return (
                                                  <td
                                                    key={h}
                                                    rowSpan={group.length}
                                                  >
                                                    {row[cleanKey] ?? "-"}{" "}
                                                    {/* ← Fixed: Use cleanKey */}
                                                  </td>
                                                );
                                              }

                                              return (
                                                <td key={h}>
                                                  {row[cleanKey] ?? "-"}{" "}
                                                  {/* ← Fixed: Use cleanKey */}
                                                </td>
                                              );
                                            })}
                                          </tr>
                                        )),
                                      )}
                                    </tbody>
                                  </table>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    Page size
                                    <Select
                                      value={pageSizeOptions.find(
                                        (opt) => opt.value === pageSize,
                                      )}
                                      onChange={(option) =>
                                        setPageSize(option.value)
                                      }
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      options={pageSizeOptions}
                                      styles={{
                                        container: (base) => ({
                                          ...base,
                                          width: 120,
                                        }),
                                      }}
                                    />
                                  </div>
                                  <PaginationControls
                                    pageIndex={pageIndex}
                                    totalPages={Math.ceil(
                                      groupedData.length / pageSize,
                                    )}
                                    setPageIndex={setPageIndex}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="card">
                <div className="card-body d-flex justify-content-center">
                  <h1>You dont have access to this page</h1>
                </div>
              </div>
            )}
          </div>
          <CommonFooter />
        </div>
      )}
    </>
  );
};

export default RollcallGroupReports;

const PaginationControls = ({ pageIndex, totalPages, setPageIndex }) => (
  <div className="d-flex justify-content-end py-3 mt-2">
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex(0)}
      disabled={pageIndex === 0}
      title="first"
    >
      <i className="fa-solid fa-backward-fast"></i>
    </button>
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex((p) => Math.max(p - 1, 0))}
      disabled={pageIndex === 0}
    >
      <i className="fa-solid fa-backward-step"></i>
    </button>

    <span>
      Page {pageIndex + 1} of {totalPages}
    </span>

    <button
      className="btn btn-primary btn-sm mx-2"
      onClick={() => setPageIndex((p) => Math.min(p + 1, totalPages - 1))}
      disabled={pageIndex >= totalPages - 1}
    >
      <i className="fa-solid fa-forward-step"></i>
    </button>
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex(totalPages - 1)}
      disabled={pageIndex >= totalPages - 1}
    >
      <i className="fa-solid fa-forward-fast"></i>
    </button>
  </div>
);

PaginationControls.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setPageIndex: PropTypes.func.isRequired,
};
